export const BottomBar = ({ children }) => {
  return (
    <div
      className="fixed bottom-0 left-0 w-full bg-white py-2 px-5"
      style={{
        boxShadow: "0px -2px 2px rgba(0, 0, 0, 0.1)",
      }}
    >
      {children}
    </div>
  )
}
